var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"upload_wrap"},[_c('el-upload',{staticClass:"avatar-uploader",attrs:{"action":"","show-file-list":false,"http-request":_vm.fnUploadRequest,"before-upload":_vm.before_upload}},[(_vm.value)?_c('img',{staticClass:"avatar",attrs:{"src":_vm.value}}):_c('i',{staticClass:"el-icon-plus avatar-uploader-icon"})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f90e386","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/upload.vue
// module id = null
// module chunks = 